import Popover from '@components/Popover'
import Pin from '@components/Pin'
import { defaultStyle as style } from 'shared/generate-marker-style'

const Marker = ({ map, lat, lng, type, name }) => {
    const showStreetView = () => {
        const location = { lat: lat, lng: lng }
        map.getStreetView()
        const sv = new google.maps.StreetViewService()
        sv.getPanorama({ location: location, radius: 50 }, processSVData)
    }

    const processSVData = (data, status) => {
        if (status === 'OK') {
            const panorama = map.getStreetView()
            panorama.setPano(data.location.pano)
            panorama.setVisible(true)
        }
    }

    return (
        <div style={style}>
            <Popover
                renderTitle={() => (
                    <span className="text-center w-100">
                        <T>map.open.streetview</T>
                    </span>
                )}
            />
            <Pin name={name} type={type} onClick={showStreetView} />
        </div>
    )
}

Marker.propTypes = {
    lat: PropTypes.number,
    lng: PropTypes.number,
    type: PropTypes.string,
    name: PropTypes.string,
}

export default Marker
